import { render, staticRenderFns } from "./TasksSummary.vue?vue&type=template&id=592993cd&scoped=true&"
import script from "./TasksSummary.vue?vue&type=script&lang=js&"
export * from "./TasksSummary.vue?vue&type=script&lang=js&"
import style0 from "./TasksSummary.vue?vue&type=style&index=0&id=592993cd&lang=scss&scoped=true&"
import style1 from "./TasksSummary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592993cd",
  null
  
)

export default component.exports